
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/[id]",
      function () {
        return require("private-next-pages/explore/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/[id]"])
      });
    }
  